export const response = ({
    success: 'Server-side Google reCaptcha validation successfull',
    failure: 'invalid-input-response'
});